import imgLogout from "@/assets/web-v3-images/not-lowest-unique.png";
import { MuiltipleButtons } from "@/component/popups/Buttons";
import { BgContentPopup } from "@/component/popups/ui-1";
import UpdateNameProfile from "@/component/popups/ui-1/UpdateNameProfile";
import { useSound } from '@/contexts/SoundContext';
import { getDataSpinUserMiniGame } from "@/Redux/futures/mini-game/action";
import { Toast } from "@/utils/helper";
import UseResponsive from "@/utils/hooks/useResponsive";
import imgExit from "@assets/web-v3-images/icons/exits.png";
import { Image, Upload } from "antd";
import ImgCrop from "antd-img-crop";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import Cookies from "universal-cookie";
import avatarDefault from "../assets/images/avatarDefault.svg";
import iconAuctionRecord from "../assets/images/iconAuctionRecord.svg";
import iconChangePassword from "../assets/images/iconChangePassword.svg";
import iconLogout from "../assets/images/iconLogout.svg";
import iconPackageHistory from "../assets/images/iconPackageHistory.svg";
import iconPlayground from "../assets/images/iconPlaygroundsvg.svg";
import ModalNotifycation from "../component/ModalNotifycation";
import API_PATH from "../config/API_PATH";
import PATH from "../config/PATH";
import { postDataApi } from "../config/service";
import {
  IS_UPDATE_VERSION_3_PROJECT,
  IS_UPDATE_VERSION_3_PROJECT_LOGIN,
  KEY_LOCAL_TOUR_COMPLETE,
  KEY_LOCAL_TYPE_USER
} from "../helper/const";
import {
  getCurrentUser,
  getTotalPieceCollected,
  getTurnRemain,
  logoutUser,
  setRedisUpdateUserInfo,
  updateProfileName,
  updateUserInfo
} from "../Redux/futures/account/actions";
import { curIsMaster, curLoyaltyPoint, curStateAccount, curStateMiniGame } from "../Redux/selector";
import { mediaQueryPoint, useMediaQuery } from "../utils/hooks";
import ComponentAccount from "./components/Account";
import { getLoyaltyPoint } from '@/Redux/futures/loyalty-point/actions';

const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

function AccountPage() {
  const cookies = new Cookies();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const selectorAccount = useSelector(curStateAccount);
  const [userInfo, setUserInfo] = useState(selectorAccount.userInfo);
  const [bidTotal, setBidTotal] = useState(0);
  const [showModallogout, setShowModalLogout] = useState(false);
  const [isdnRerral, setIsdnRerral] = useState("");
  const [dataApiSuccess, setDataApiSuccess] = useState(null);
  const [openUpdateName, setOpenUpdateName] = useState(false);
  const [valueName, setValueName] = useState("Cristela Estilista");
  const [turn, setTurn] = useState(0);
  const [totalPiece, setTotalPiece] = useState(0);
  const [getDataApiUser, setGetDataApiUser] = useState(null);
  const isMaster = useSelector(curIsMaster);

  const [stateModal, setStateModal] = useState({
    open: false,
    title: t("error"),
    message: "",
  });
  const [isShowPopupReferredSuccess, setIsShowPopupReferredSuccess] =
    useState(false);
  const uploadRef = useRef(null);
  const [fileList, setFileList] = useState([
    {
      uid: "-1",
      name: "avatar.svg",
      status: "done",
      url: userInfo?.image || avatarDefault,
    },
  ]);

  const dataMiniGame = useSelector(curStateMiniGame);
  const [previewVisible, setPreviewVisible] = useState(false);
  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoint.lg}px)`);
  const afterGetUserInfo = (data, isLoading) => {
    if (!isLoading) {
      if (data) {
        setUserInfo(data.data);
      } else {
        navigate(PATH.HOME);
      }
    }
  };
  const afterUpdateUserInfo = (data, isLoading) => {
    if (data) {
      if (data.success) {
        setStateModal({
          open: true,
          title: t("success"),
          message: data.message,
        });
        toast.success(data.message);
      } else {
        setStateModal({
          open: true,
          title: t("error"),
          message: data.errorMessage,
        });
        toast.error(data.errorMessage);
      }
      getUserInfo();
    }
  };
  useEffect(() => {
    if (selectorAccount.remainTurn) {
      const bidTotal = selectorAccount.remainTurn?.reduce((acc, pack) => {
        return acc + pack?.turn;
      }, 0);
      setBidTotal(bidTotal);
    }
  }, [selectorAccount.remainTurn]);
  useEffect(() => {
    let urlAvatar = avatarDefault;
    if (userInfo && userInfo?.image) {
      const myPromise = new Promise((resolve, reject) => {
        resolve(userInfo?.image);
      });
      myPromise.then((res) => {
        if (res) {
          urlAvatar = userInfo?.image;
        }
        setFileList([{ ...fileList[0], url: urlAvatar }]);
      });
    }
    setValueName(userInfo?.name || "");
  }, [userInfo]);
  const getUserInfo = () => {
    dispatch(getCurrentUser({ callback: afterGetUserInfo }));
  };
  useEffect(() => {
    if (!userInfo) {
      getUserInfo();
    }
    dispatch(getTurnRemain({}));
  }, []);
  useEffect(() => {
    if (getDataApiUser) {
      const newData = {
        ...selectorAccount.userInfo,
        name: valueName,
      };
      dispatch(setRedisUpdateUserInfo(newData));
    }
  }, [getDataApiUser]);
  useEffect(() => {
    if (fileList.length > 0) {
      if (fileList[0].status === "done" && fileList[0].response) {
        let body = {
          image: fileList[0].response.file,
          displayName: selectorAccount?.userInfo?.name,
          emailAddress: selectorAccount?.userInfo?.email,
          isdn: selectorAccount?.userInfo?.isdn,
          callback: afterUpdateUserInfo,
        };
        dispatch(updateUserInfo(body));
      }
    }
  }, [fileList[0].status]);
  const handleLogout = () => {
    setShowModalLogout(true);
  };
  const listLinkAccounts = [
    {
      label: t("account_page.package_history"),
      link: PATH.PACKAGE_HISTORY,
      icons: iconPackageHistory,
    },
    {
      label: t("account_page.auction_record"),
      link: PATH.AUCTION_RECORD,
      icons: iconAuctionRecord,
    },
    {
      label: t("account_page.change_password"),
      link: PATH.CHANGE_PASSWORD,
      icons: iconChangePassword,
    },
    {
      label: t("playground.title"),
      link: PATH.PLAYGROUND,
      icons: iconPlayground,
    },
    {
      label: t("account_page.logout"),
      link: handleLogout,
      icons: iconLogout,
    },
  ];
  const handleConfirmLogout = async () => {
    setShowModalLogout(false);
    await dispatch(logoutUser({}));
    IS_UPDATE_VERSION_3_PROJECT_LOGIN ? navigate(PATH.HOME) : navigate(PATH.LOGIN);
    sessionStorage.setItem("logout", true);
    cookies.remove("hidden-popup-change-pw");
    localStorage.removeItem(KEY_LOCAL_TYPE_USER);
    localStorage.removeItem(KEY_LOCAL_TOUR_COMPLETE);
  };
  const handleChangeAvarta = ({ fileList, file }) => {
    if (fileList.length > 0) {
      setFileList(fileList);
    }
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    setPreviewVisible(true);
  };
  const onRemove = () => {
    setFileList([
      {
        uid: "-1",
        name: "avatar.svg",
        status: "done",
        url: avatarDefault,
      },
    ]);
    let body = {
      image: "",
      displayName: selectorAccount?.userInfo?.name,
      emailAddress: selectorAccount?.userInfo?.email,
      isdn: selectorAccount?.userInfo?.isdn,
      callback: afterUpdateUserInfo,
    };
    dispatch(updateUserInfo(body));
  };

  const afterUpdateUserName = (data, isLoading) => {
    if (data?.success) {
      setGetDataApiUser(Date.now());
      Toast.success(data.message || "Update Name Success!");
    }
  };

  const handleSubmitReferral = async () => {
    if (!isdnRerral) {
      return;
    }
    const body = {
      referral_isdn: isdnRerral,
    };
    const dataApi = await postDataApi(API_PATH.enterReferralFriend, body);
    if (dataApi.success) {
      setIsShowPopupReferredSuccess(true);
      setDataApiSuccess(dataApi);
      getUserInfo();
      return;
    }
    setIsShowPopupErr(true);
  };
  const [isShowPopupErr, setIsShowPopupErr] = useState(false);
  const handleClosePopupError = () => {
    setIsShowPopupErr(false);
  };

  const handleOpenUpload = () => {
    uploadRef.current?.nativeElement?.querySelector("input")?.click();
  };

  const { dataSpinUserMini } = useSelector(curStateMiniGame);
  const { loyaltyPoint } = useSelector(curLoyaltyPoint);

  useEffect(() => {
    IS_UPDATE_VERSION_3_PROJECT && dispatch(getLoyaltyPoint({}));
  }, [])

  useEffect(() => {
    dispatch(getDataSpinUserMiniGame());
    dispatch(
      getTurnRemain({
        callback: (data, loading) => {
          if (!loading) {
            const totalTurn = (data?.data || []).reduce(
              (sum, item) => sum + (item.turn || 0),
              0,
            );
            setTurn(totalTurn);
          }
        },
      }),
    );
    dispatch(
      getTotalPieceCollected({
        callback: (data, loading) => {
          if (!loading) {
            setTotalPiece(data?.data?.total_piece);
          }
        },
      }),
    );
  }, []);

  // new v3
  const { isOn, setIsOn } = useSound();

  return (
    <>
      <UseResponsive>
        <ComponentAccount
          fileList={fileList}
          isOnMussic={isOn}
          setIsOnMussic={setIsOn}
          handlePreview={() => setPreviewVisible(true)}
          setShowModalLogout={setShowModalLogout}
          handleOpenUpload={handleOpenUpload}
          valueName={valueName}
          setOpenUpdateName={setOpenUpdateName}
          userInfo={userInfo}
          dataSpinUserMini={dataSpinUserMini}
          loyaltyPoint={loyaltyPoint}
          turn={turn}
          totalPiece={totalPiece}
          handleDelete={onRemove}
          isMaster={isMaster}
        />
        {previewVisible && (
          <Image
            className="modal-preview"
            wrapperStyle={{
              display: "none",
            }}
            preview={{
              visible: previewVisible,
              onVisibleChange: (visible) => setPreviewVisible(visible),
              afterOpenChange: (visible) => !visible && setPreviewVisible(""),
            }}
            src={fileList[0].url}
          />
        )}
      </UseResponsive>
      <ModalNotifycation
        open={showModallogout}
        handleCancel={() => {
          setShowModalLogout(false);
        }}
        handleOk={handleConfirmLogout}
        topIcon={imgLogout}
        title={t("confirmation")}
        message={t("modal.logout")}
        isVersion3
      />
      <div className="avarta hidden">
        <ImgCrop
          cropShape="round"
          modalTitle={
            <div>
              <div
                className="absolute z-1 left-1/2 -translate-x-1/2 top-4 sm:top-5 md:top-5 lg:top-5 xl:top-5
                      !text-[16px] sm:!text-[25px] md:!text-[30px] lg:!text-[30px] xl:!text-[30px]
                      font-black leading-none text-[#FCF8E9]"
                style={{
                  textShadow: `
                        0 8px 12px rgba(208,69,14,.35),
                        0 4px 6px rgba(208,69,14,.45)
                      `,
                }}
              >
                {t("account_page.edit_image")}
              </div>
              <BgContentPopup>
                <div style={{ width: "80%", height: "420px" }}></div>
                <div
                  className=""
                  style={{
                    display: "flex",
                    gap: "12px",
                    position: "relative",
                    top: "36px",
                    height: "101px",
                  }}
                ></div>
              </BgContentPopup>
            </div>
          }
          modalOk={
            <MuiltipleButtons
              handleClick={() => { }}
              textBtn={t("modal.modal_login.ok")}
              classItem="mb-[0]"
            />
          }
          modalCancel={
            <div>
              <MuiltipleButtons
                handleClick={() => { }}
                textBtn={t("account_page.package.cancel")}
                classItem="mb-[0]"
              />
              <img src={imgExit} className="btn-close-popup-upload" alt="" />
            </div>
          }
          modalClassName="my-img-crop-modal"
        >
          <Upload
            ref={uploadRef}
            listType="picture-card"
            maxCount={1}
            accept="image/*"
            fileList={fileList}
            onChange={handleChangeAvarta}
            onPreview={handlePreview}
            onRemove={onRemove}
            action={API_PATH.upload}
          >
            <div className="icon-camera" />
          </Upload>
        </ImgCrop>
        {previewVisible && (
          <Image
            className="modal-preview"
            wrapperStyle={{
              display: "none",
            }}
            preview={{
              visible: previewVisible,
              onVisibleChange: (visible) => setPreviewVisible(visible),
              afterOpenChange: (visible) => !visible && setPreviewVisible(""),
            }}
            src={fileList[0].url}
          />
        )}
      </div>
      <UpdateNameProfile
        open={openUpdateName}
        onOpenChange={setOpenUpdateName}
        valueName={selectorAccount.userInfo?.name}
        onChangeUpdateName={async (newName) => {
          await dispatch(
            updateProfileName({
              displayName: newName,
              callback: afterUpdateUserName,
            }),
          );
          setValueName(newName);
        }}
      />
    </>
  );
  //   return (
  //     <div className="container-account">
  //       {isShowPopupErr ? (
  //         <ModalNotifycation
  //           open={isShowPopupErr}
  //           handleCancel={handleClosePopupError}
  //           title={t("error")}
  //           message={"လုပ်ဆောင်နေစဉ်ပြဿနာပေါ်လာပါတယ်။ ထပ်မံကြိုးစားပေးပါ။"}
  //           isContainer
  //         />
  //       ) : null}

  //       {userInfo && (
  //         <div className="container-account-info">
  //           {isMobile ? <div className="container-account-info-bgr" /> : null}
  //           <div className="container-account-info-user">
  //             <div className="avarta">
  //               <ImgCrop
  //                 modalTitle={t("account_page.edit_image")}
  //                 modalOk={t("modal.modal_login.ok")}
  //                 modalCancel={t("account_page.package.cancel")}
  //               >
  //                 <Upload
  //                   listType="picture-card"
  //                   maxCount={1}
  //                   accept="image/*"
  //                   fileList={fileList}
  //                   onChange={handleChangeAvarta}
  //                   onPreview={handlePreview}
  //                   onRemove={onRemove}
  //                   action={API_PATH.upload}
  //                 >
  //                   <div className="icon-camera" />
  //                 </Upload>
  //               </ImgCrop>
  //               {previewVisible && (
  //                 <Image
  //                   className="modal-preview"
  //                   wrapperStyle={{
  //                     display: "none",
  //                   }}
  //                   preview={{
  //                     visible: previewVisible,
  //                     onVisibleChange: (visible) => setPreviewVisible(visible),
  //                     afterOpenChange: (visible) =>
  //                       !visible && setPreviewVisible(""),
  //                   }}
  //                   src={fileList[0].url}
  //                 />
  //               )}
  //             </div>
  //             <span className="name">{userInfo?.msisdn}</span>
  //           </div>
  //           <div className="container-account-info-foot">
  //             <div className="total-bid">
  //               <div className="total-bid-icon" />
  //               <div className="total-bid-number">
  //                 <span>{bidTotal}</span>
  //               </div>
  //             </div>
  //             <div
  //               onClick={() => navigate(PATH.PACKAGE)}
  //               className="buy-more-bid"
  //             >
  //               <div className="icon-cart" />
  //               <div className="buy-more-text">
  //                 {" "}
  //                 {t("account_page.buy_more_bid")}
  //               </div>
  //             </div>
  //           </div>
  //           {/* {dataMiniGame?.configMiniGame?.is_show ? (
  //             <div>
  //               {!userInfo?.isdn_referral ? (
  //                 <>
  //                   <div className="info-referral">
  //                     <Space.Compact
  //                       style={{ borderRadius: "9999px", overflow: "hidden" }}
  //                     >
  //                       <div className="referral-isdn referral-isdn-success" style={{fontSize: "14px"}}>ရည်ညွှန်း ဖုန်းနံပါတ်ကို</div>
  //                       <Input
  //                         onChange={(e) => {
  //                           const onlyNums = e.target.value.replace(/\D/g, "");
  //                           setIsdnRerral(onlyNums);
  //                         }}
  //                         value={isdnRerral}
  //                         placeholder="ရည်ညွှန်းဖုန်းနံပါတ်ကို ထည့်"
  //                         allowClear
  //                         className="input-referral"
  //                         style={{
  //                           borderRadius: "0 9999px 9999px 0",
  //                           backgroundColor: "#E4E1EC",
  //                           border: "none",
  //                           width: 250,
  //                         }}
  //                       />
  //                     </Space.Compact>

  //                     <div
  //                       className="btn-submit-referral"
  //                       onClick={handleSubmitReferral}
  //                     >
  //                        တင်သွင်းပါ။
  //                     </div>
  //                   </div>
  //                   <div className="info-referral-content">
  //                     အကောင့်တစ်ခုစီသည် လွှဲပြောင်းမှုတစ်ခုနှင့်သာ ချိတ်ဆက်နိုင်သည်။
  // ချိတ်ဆက်ပြီးသည်နှင့်၊ နှစ်ဦးလုံးသည် SUPER Coin 1 ခု ရရှိပါမည်။
  //                   </div>
  //                 </>
  //               ) : (
  //                 <>
  //                   <div className="info-referral info-referral-success">
  //                     <Space.Compact
  //                       style={{ borderRadius: "9999px", overflow: "hidden" }}
  //                     >
  //                       <div className="referral-isdn">ရည်ညွှန်း ဖုန်းနံပါတ်ကို</div>
  //                       <input
  //                         value={userInfo?.isdn_referral}
  //                         placeholder="ရည်ညွှန်းဖုန်းနံပါတ်ကို ထည့်"
  //                         allowClear
  //                         style={{
  //                           borderRadius: "0 9999px 9999px 0",
  //                           backgroundColor: "#E4E1EC",
  //                           border: "none",
  //                           width: 280,
  //                           pointerEvents: "none",
  //                           paddingLeft: "20px",
  //                         }}
  //                         className="input-referral__success"
  //                       />
  //                     </Space.Compact>
  //                   </div>
  //                   <div className="info-referral-content info-referral-content__success">
  //                     အကောင့်တစ်ခုစီသည် လွှဲပြောင်းမှုတစ်ခုနှင့်သာ ချိတ်ဆက်နိုင်သည်။
  //                   </div>
  //                 </>
  //               )}
  //             </div>
  //           ) : null} */}
  //         </div>
  //       )}
  //       <div className="container-account-link">
  //         {listLinkAccounts.map((item, index) => {
  //           // Hide playground on desktop
  //           if (item.link === PATH.PLAYGROUND && !isMobile) {
  //             return null;
  //           }

  //           if (typeof item.link === "function") {
  //             return (
  //               <div
  //                 className="container-account-link-item"
  //                 onClick={() => item.link()}
  //               >
  //                 <div className="box-link">
  //                   <div
  //                     className="icon-link"
  //                     style={{ backgroundImage: `url(${item.icons})` }}
  //                   />
  //                   <div className="box-link-label">{item.label}</div>
  //                 </div>
  //                 <div className="icon-next" />
  //               </div>
  //             );
  //           }
  //           return (
  //             <Link className="container-account-link-item" to={item.link}>
  //               <div className="box-link">
  //                 <div
  //                   className="icon-link"
  //                   style={{ backgroundImage: `url(${item.icons})` }}
  //                 />
  //                 <div className="box-link-label">{item.label}</div>
  //               </div>
  //               <div className="icon-next" />
  //             </Link>
  //           );
  //         })}
  //       </div>
  //       <ModalNotifycation
  //         open={showModallogout}
  //         handleCancel={() => {
  //           setShowModalLogout(false);
  //         }}
  //         handleOk={handleConfirmLogout}
  //         title={t("confirmation")}
  //         message={t("modal.logout")}
  //       />
  //       <ModalNotifycation
  //         open={stateModal.open}
  //         handleCancel={() => {
  //           setStateModal({
  //             open: false,
  //             title: t("error"),
  //             message: "",
  //           });
  //         }}
  //         title={stateModal.title}
  //         message={stateModal.message}
  //       />
  //       {isShowPopupReferredSuccess ? (
  //         <PopupCongGivePiece
  //           type={TYPE_GIVE_PIECE_SUCCESS.referral_successful}
  //           data={dataApiSuccess}
  //           handleClose={() => setIsShowPopupReferredSuccess(false)}
  //         />
  //       ) : null}
  //     </div>
  //   );
}

export default AccountPage;
